import { render, staticRenderFns } from "./TreasuryDelete.vue?vue&type=template&id=1ce37943&scoped=true&"
import script from "./TreasuryDelete.vue?vue&type=script&lang=js&"
export * from "./TreasuryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce37943",
  null
  
)

export default component.exports